var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content auto_list_block" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-9" },
            [
              _vm.cities.length
                ? _c("multiSelectDrugs", {
                    ref: "selectedDrugs",
                    attrs: {
                      cities: _vm.cities,
                      searchOrders: _vm.searchOrders,
                      filterUpdated: _vm.filterUpdated,
                      cityUpdated: _vm.cityUpdated,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isAllowToUse.showAllowedToSend
                ? _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.showAllowedToUse,
                          expression: "showAllowedToUse",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "gridCheck2" },
                      domProps: {
                        checked: Array.isArray(_vm.showAllowedToUse)
                          ? _vm._i(_vm.showAllowedToUse, null) > -1
                          : _vm.showAllowedToUse,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.showAllowedToUse,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.showAllowedToUse = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.showAllowedToUse = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.showAllowedToUse = $$c
                            }
                          },
                          _vm.updateOrdersVisibility,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "gridCheck2" },
                      },
                      [
                        _vm._v(
                          "\n              показывать только те заявки, товар которых есть в распоряжении\n            "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isAllowToUse.incomeStore
                ? _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.allowSupplyDrugs,
                          expression: "allowSupplyDrugs",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "gridCheck3" },
                      domProps: {
                        checked: Array.isArray(_vm.allowSupplyDrugs)
                          ? _vm._i(_vm.allowSupplyDrugs, null) > -1
                          : _vm.allowSupplyDrugs,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.allowSupplyDrugs,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.allowSupplyDrugs = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.allowSupplyDrugs = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.allowSupplyDrugs = $$c
                            }
                          },
                          _vm.updateOrdersVisibility,
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "gridCheck3" },
                      },
                      [
                        _vm._v(
                          "\n              учитывать возможность пополнения склада\n            "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-check" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.usePagination,
                      expression: "usePagination",
                    },
                  ],
                  staticClass: "form-check-input",
                  attrs: { type: "checkbox", id: "gridCheck4" },
                  domProps: {
                    checked: Array.isArray(_vm.usePagination)
                      ? _vm._i(_vm.usePagination, null) > -1
                      : _vm.usePagination,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.usePagination,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.usePagination = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.usePagination = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.usePagination = $$c
                        }
                      },
                      function ($event) {
                        return _vm.updateCheckboxes("pagination")
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label poi",
                    attrs: { for: "gridCheck4" },
                  },
                  [
                    _vm._v(
                      "\n              использовать постраничный вывод заявок\n            "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action_btn" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.searchOrderBtnLoading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.searchOrders()
                        },
                      },
                    },
                    [_vm._v("Поиск\n            ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", [
              _c("label", { attrs: { for: "" } }, [
                _vm._v("Поиск (заявка, телефон, препарат)"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchData,
                    expression: "searchData",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.searchData },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchData = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm.$currentRole == "admin"
              ? _c("div", [
                  _c("label", { attrs: { for: "" } }, [_vm._v("DEBUG")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.debugDrug,
                        expression: "debugDrug",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.debugDrug },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.debugDrug = $event.target.value
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.projectToSelect && _vm.projectToSelect.length
              ? _c("div", [
                  _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.myProjects,
                          expression: "myProjects",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "gridCheck5" },
                      domProps: {
                        checked: Array.isArray(_vm.myProjects)
                          ? _vm._i(_vm.myProjects, null) > -1
                          : _vm.myProjects,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a = _vm.myProjects,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.myProjects = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.myProjects = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.myProjects = $$c
                            }
                          },
                          function ($event) {
                            return _vm.updateCheckboxes("myProject")
                          },
                        ],
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label pointer",
                        attrs: { for: "gridCheck5" },
                      },
                      [
                        _vm._v(
                          "\n                Показывать мои проекты\n              "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("multiselect", {
                        attrs: {
                          name: "user_role",
                          options: _vm.projectToSelect,
                          "data-vv-as": "Выбрать проекты",
                          "track-by": "name",
                          label: "name",
                          "show-labels": false,
                          placeholder: "Выберите проекты",
                          multiple: true,
                        },
                        on: { input: () => {} },
                        model: {
                          value: _vm.selectedProjects,
                          callback: function ($$v) {
                            _vm.selectedProjects = $$v
                          },
                          expression: "selectedProjects",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.usePagination && _vm.paginator
          ? _c(
              "div",
              { staticClass: "pull-right" },
              [
                _c("p", [
                  _vm._v("Всего заявок: "),
                  _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                ]),
                _vm._v(" "),
                _vm.paginator
                  ? _c("paginate", {
                      attrs: {
                        "page-count": _vm.paginator.last_page,
                        "page-range": 6,
                        "margin-pages": 2,
                        "click-handler": _vm.searchOrders,
                        "prev-text": "&laquo",
                        "next-text": "&raquo",
                        "container-class": "pagination",
                        "prev-class": "page-item",
                        "prev-link-class": "page-link",
                        "page-class": "page-item",
                        "page-link-class": "page-link",
                        "next-class": "page-item",
                        "next-link-class": "page-link",
                        "active-class": "active green_btn",
                      },
                      model: {
                        value: _vm.currentPage,
                        callback: function ($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    Object.keys(_vm.orders).length || _vm.searchLoading
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: { loading: _vm.searchLoading, color: _vm.loadingColor },
              }),
              _vm._v(" "),
              Object.keys(_vm.orders).length
                ? _c("ordersList", {
                    ref: "ordersList",
                    attrs: {
                      orders: _vm.orders,
                      newStoreData: _vm.newStoreData,
                      projects: _vm.projects,
                      cities: _vm.citiesMapped,
                      subStatuses: _vm.subStatuses,
                      displayType: "natural",
                      allowToHotCall: _vm.allowToHotCall,
                      externalUpdateOrder: _vm.updateOrder,
                      resetSubStatus: "true",
                      inStore: _vm.inStore,
                      inSendStore: _vm.inSendStore,
                      drugsTransits: _vm.drugsTransits,
                      editComment: "true",
                      updateDynamicStoreDataByOrder:
                        _vm.updateDynamicStoreDataByOrder,
                      debugDrug: _vm.debugDrug,
                      drugDynamicStoreData: _vm.drugDynamicStoreData,
                      availableToSend: _vm.availableToSend,
                      disableSupplyDrugs: _vm.disableSupplyDrugs,
                      allowSupplyDrugs: _vm.allowSupplyDrugs,
                      confirmedDrugs: _vm.confirmedDrugs,
                      updateConfirmedDrug: _vm.updateConfirmedDrug,
                      searchOrders: _vm.searchOrders,
                      sorting: _vm.sorting,
                      allowToCall: true,
                      type: "storeDetailed",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.usePagination &&
              Object.keys(_vm.orders).length &&
              _vm.paginator
                ? _c(
                    "div",
                    { staticClass: "pull-right" },
                    [
                      _c("p", [
                        _vm._v("Всего заявок: "),
                        _c("strong", [_vm._v(_vm._s(_vm.paginator.total))]),
                      ]),
                      _vm._v(" "),
                      _vm.paginator
                        ? _c("paginate", {
                            attrs: {
                              "page-count": _vm.paginator.last_page,
                              "page-range": 6,
                              "margin-pages": 2,
                              "click-handler": _vm.searchOrders,
                              "prev-text": "&laquo",
                              "next-text": "&raquo",
                              "container-class": "pagination",
                              "prev-class": "page-item",
                              "prev-link-class": "page-link",
                              "page-class": "page-item",
                              "page-link-class": "page-link",
                              "next-class": "page-item",
                              "next-link-class": "page-link",
                              "active-class": "active green_btn",
                            },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(
      "\n\n  " +
        _vm._s(Object.keys(_vm.readyToSend).length) +
        " " +
        _vm._s(this.allowSupplyDrugs) +
        " " +
        _vm._s(!_vm.searchLoading) +
        "\n  "
    ),
    Object.keys(_vm.readyToSend).length &&
    this.allowSupplyDrugs &&
    !_vm.searchLoading
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("div", { staticClass: "flex justify-content-between" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.allowToDownload
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.createInvoice,
                              expression: "createInvoice",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "checkbox", id: "gridCheck44" },
                          domProps: {
                            checked: Array.isArray(_vm.createInvoice)
                              ? _vm._i(_vm.createInvoice, null) > -1
                              : _vm.createInvoice,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.createInvoice,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.createInvoice = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.createInvoice = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.createInvoice = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "gridCheck44" },
                          },
                          [
                            _vm._v(
                              "\n              создать накладную перемещения\n            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "vue-ladda",
                        {
                          attrs: {
                            "button-class": "btn btn-success",
                            "data-style": "zoom-in",
                            loading: _vm.downloadXLSLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.exportExcelToFile()
                            },
                          },
                        },
                        [_vm._v("Скачать XLSX\n          ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-sm table-hover" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.readyToSendList, function (drug, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(index + 1))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.drugsNames[drug.id].cool
                        ? _c("span", { staticClass: "icon icon-snowflake" })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("p", [
                        _vm._v(
                          _vm._s(drug.name) + " (" + _vm._s(drug.id) + ")"
                        ),
                      ]),
                      _vm._v(" "),
                      drug.drug &&
                      drug.drug.pack_set &&
                      +drug.drug.pack_set !== 1
                        ? _c("p", { staticClass: "pack_details" }, [
                            _vm._v("Препарат комплектный: "),
                            _c("span", { staticClass: "badge badge-info" }, [
                              _vm._v("1 комплект"),
                            ]),
                            _vm._v(" -\n              "),
                            _c("strong", [_vm._v(_vm._s(drug.drug.pack_set))]),
                            _vm._v(" (зав.уп.)"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.drugsNames[drug.id].pack_comment
                        ? _c("p", { staticClass: "pack_details" }, [
                            _vm._v(
                              _vm._s(_vm.drugsNames[drug.id].pack_comment)
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.drugsNames[drug.id].pack_box_comment
                        ? _c("p", { staticClass: "pack_box_details" }, [
                            _vm._v(
                              _vm._s(_vm.drugsNames[drug.id].pack_box_comment)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n            " + _vm._s(drug.qty.toFixed(2)) + " "
                      ),
                      _vm.drugsNames[drug.id].pack_set &&
                      _vm.drugsNames[drug.id].pack_set !== 1
                        ? _c("span", [
                            _vm._v(
                              "компл. (" +
                                _vm._s(
                                  Math.round(
                                    _vm.drugsNames[drug.id].pack_set * drug.qty
                                  )
                                ) +
                                " з.уп.)"
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    Object.keys(_vm.confirmedButNoAbleToSendList).length
      ? _c("div", { staticClass: "card" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-sm table-hover" }, [
              _vm._m(3),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(
                  _vm.confirmedButNoAbleToSendList,
                  function (qty, drugId, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [_vm._v(_vm._s(index + 1))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.drugsNames[drugId].name) +
                            " (" +
                            _vm._s(drugId) +
                            ")"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(qty))]),
                    ])
                  }
                ),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h5", [_vm._v("Готовим к отправке с ближайшим трансфером")]),
      _vm._v(" "),
      _c("small", [
        _vm._v(
          "список собран на основе полного автосписка, без учета постраничного вывода"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Количество")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Подтверждено, но нет вожможности отправить")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Количество")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }